import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "border-gray-light/40 text-body-2 flex w-full rounded-lg border bg-white px-4 py-3 text-secondary-800 subpixel-antialiased outline-none file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-secondary-400 ",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
